<template>
  <v-container>
    <div class="editorx_body">
      <!--editorjs id-->
      <div class :id="`codex-editor-${id}`" />
    </div>
    <div class="editorx_body"></div>
  </v-container>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "editorjs-header-with-anchor";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
import SimpleImage from "@editorjs/simple-image";

export default {
  name: "editor",
  data() {
    return {
      editor: null,
      id: Math.random(),
    };
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    data: {
      default: () => ({
        time: 1550476186479,
        blocks: [],
        version: "2.8.1",
      }),
    },
  },
  mounted() {
    this.setupEditor();
  },
  watch: {
    data: function (newVal) {
      try {
        this.editor.clear();
        this.editor.render(newVal);
      } catch (e) {
        this.setupEditor();
        this.editor.clear();
        this.editor.render(this.$props.data);
      }
    },
  },
  methods: {
    childSave() {
      return this.editor.save().then((savedData) => {
        return savedData;
      });
    },
    setupEditor() {
      this.editor = new EditorJS({
        readOnly: this.$props.readOnly,
        holder: `codex-editor-${this.id}`,
        autofocus: true,
        onReady: function () {
          console.log("ready");
        },
        data: this.$props.data,
        tools: {
          header: {
            class: Header,
            shortcut: "CMD+SHIFT+H",
            config: {
              placeholder: "Enter a header",
              levels: [2, 3, 4],
              defaultLevel: 3,
              allowAnchor: true,
              anchorLength: 100,
            },
          },
          list: {
            class: List,
          },
          paragraph: {
            class: Paragraph,
            config: {
              placeholder: ".",
            },
          },
          image: {
            class: SimpleImage,
            inlineToolbar: true,
            config: {
              placeholder: "Paste image URL",
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.codex-editor__redactor {
  display: none;
}
</style>

